export default {"src":"/_next/static/media/bx-sitemap.d3606300.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};